<!--  This is an example of a custom content component for standard Aero dialogs -->
<div style="text-align: center">
  <p-checkbox inputId="test-custom-dialog-primary-disabled"
              [(ngModel)]="primaryDisabled"
              (onChange)="updatePrimary()"
              [binary]="true">
  </p-checkbox>
  <label for="test-custom-dialog-primary-disabled">
    {{ config.primaryLabel }} Button Disabled
  </label>
</div>
